export default "__VITE_ASSET__iwMXXhLt__"